import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  containerTableBox: {
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '0.5rem',
    padding: '1.5rem',
    marginBottom: '1.5rem',
    backgroundColor: '#FFFFFF',

    '& .MuiTableCell-root': {
      backgroundColor: `#FFFFFF !important`,
    },
  },
}))

export { useStyles }
